import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface MobileAppDialogData {
  storeUrl: string;
  storeName: string;
}

@Component({
  selector: 'app-mobile-app-dialog',
  imports: [MatDialogModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './mobile-app-dialog.component.html',
  styleUrl: './mobile-app-dialog.component.scss',
})
export class MobileAppDialogComponent {
  readonly data = inject<MobileAppDialogData>(MAT_DIALOG_DATA);
}
